import React, { Component } from "react";
// import { ProgressBar } from "react-bootstrap";
import "../../../../App.css";
import { Form, Row, Col, Button, Card } from "react-bootstrap";
// import { Form, Nav, Tab, Row, Col, Button, Card } from "react-bootstrap";
// import DatePicker from "react-datepicker";
import Swal from "sweetalert2";
import supportSeriveApliCall from "../../../../Services/supportservice";
import Usersession from "../../../../Services/sessionservice";
import Exceptionservice from "../../../../Services/exception";
import SecureLS from "secure-ls";
export class Admintickettrack extends Component {
  constructor() {
    super();
    this.state = {
      startDate: "",
      userDetailsbyTicketIdData: [],
      Allsupportcomment: [],
      commentValue: "",
      commentValueErrormsg: "",
    };
    this.getsupportSeriveApliCall = new supportSeriveApliCall();
    this.sd = new Usersession();
    this.getExceptionservice = new Exceptionservice();
  }
  showticketdetails = (e) => {
    // console.log("e", e.target);
    let id = e.target.id;
    this.props.history.push(`/admintickettrack/${id}`);
  };
  createSupportCommentByTicketId = () => {
    var ls = new SecureLS();
    // let uuid = ls.get("key1").uuid;
    let userFirstName = ls.get("key1").firstName;
    let userLastName = ls.get("key1").lastName;
    let userType = ls.get("key1").userType;
    let fullName = `${userFirstName} ${userLastName}`;
    console.log("userName", fullName);

    let {
      match: { params },
    } = this.props;
    // console.log("params", params.userId)
    let TicketID = params.userId;
    let commentasupport = [
      {
        comment: this.state.commentValue,
        userType: userType,
        fullName: fullName,
      },
    ];
    if (this.state.commentValue === "") {
      this.setState({
        commentValueErrormsg: "Comment can't emplty.Kindly write comment.",
      });
    } else {
      this.setState({ submitLoading: true });
      this.getsupportSeriveApliCall
        .AdminCreateSupportCommentByTicketId(TicketID, commentasupport)
        .then((result) => {
          // console.log("support comment send by admin", result.data)
          if (result.data.successCode === "API_SUCCESS") {
            this.setState({ submitLoading: false, commentValue: "" });
            this.getAdminViewDetailsByTicketId();
          }
        });
    }
  };
  onChangecomment = (e) => {
    this.setState({ commentValue: e.target.value, commentValueErrormsg: "" });
  };
  handleChange = (e) => {
    // console.log("e", e);
    this.setState({ startDate: e });
  };
  async componentDidMount() {
    await this.sd.getusersession();
    this.getAdminViewDetailsByTicketId();
  }
  closetickethandler = () => {
    let {
      match: { params },
    } = this.props;
    // console.log("params", params.userId)
    let TicketID = params.userId;
    this.getsupportSeriveApliCall
      .AdminChangeSupportStatusByTicketId(TicketID, "CLOSE")
      .then((result) => {
        // console.log("resut of change status open", result.data)
        this.getAdminViewDetailsByTicketId();
        this.setState(this.state.userDetailsbyTicketIdData);
        // message.success("Ticket close successfully.")
        Swal.fire("Ticket Sucessfully closed");
      });
  };
  opentickethandler = () => {
    let {
      match: { params },
    } = this.props;
    // console.log("params", params.userId)
    let TicketID = params.userId;
    this.setState({ opentickbtnLoading: true });
    this.getsupportSeriveApliCall
      .AdminChangeSupportStatusByTicketId(TicketID, "OPEN")
      .then((result) => {
        // console.log("resut of change status open", result.data)
        this.getAdminViewDetailsByTicketId();
        this.setState(this.state.userDetailsbyTicketIdData);
        Swal.fire("Ticket open successfully");
        // this.setState({ opentickbtnLoading: false })
      });
  };
  reopenTickethandler = () => {
    let {
      match: { params },
    } = this.props;
    // console.log("params", params.userId)
    let TicketID = params.userId;
    this.getsupportSeriveApliCall
      .AdminChangeSupportStatusByTicketId(TicketID, "REOPEN")
      .then((result) => {
        // console.log("resut of change status open", result.data)
        this.getAdminViewDetailsByTicketId();
        this.setState(this.state.userDetailsbyTicketIdData);
        Swal.fire("Ticket Reopen successfully");
      });
  };
  getAdminViewDetailsByTicketId = () => {
    let {
      match: { params },
    } = this.props;
    // console.log("params", params.userId);
    let TicketID = params.userId;
    // console.log("this.props.location.search", TicketID);
    this.getsupportSeriveApliCall
      .AdminViewDetailsByTicketId(TicketID)
      .then((result) => {
        // console.log("admin view details by ticket ID", result.data);
        result.data.extraData.SupportInfo.extraData.comment =
          result.data.extraData.SupportInfo.extraData.comment.sort(function (
            a,
            b
          ) {
            return a.id - b.id;
          });
        this.setState({
          userDetailsbyTicketIdData: result.data.extraData.SupportInfo,
        });

        this.setState({
          Allsupportcomment:
            this.state.userDetailsbyTicketIdData.extraData.comment.reverse(),
        });
      });
  };
  render() {
    return (
      <div>
        <div className="page-header">
          <h3 className=" page-title">AdminSupport </h3>
          <nav aria-label="breadcrumb">
            <ol className="breadcrumb">
              <li className="breadcrumb-item">
                <a href="!#" onClick={(event) => event.preventDefault()}>
                  Support
                </a>
              </li>
              <li className="breadcrumb-item active" aria-current="page">
                Admin
              </li>
            </ol>
          </nav>
        </div>
        <div className="row">
          <div className="col-lg-12 grid-margin stretch-card">
            <Card style={{ padding: 20 }}>
              <p className="ptageticketrack">
                Ticket ID:
                <span className="spantitrack">
                  {this.state.userDetailsbyTicketIdData.tokenId}
                </span>
              </p>
              <Card.Title>
                {this.state.userDetailsbyTicketIdData.supportTicketStatus ===
                "NEW" ? (
                  <div>
                    <Row>
                      <Col>
                        <Button
                          color="primary"
                          onClick={this.opentickethandler}
                        >
                          Open Ticket
                        </Button>
                      </Col>
                      <Col>
                        <Button
                          color="danger"
                          style={{ marginLeft: 60 }}
                          onClick={this.closetickethandler}
                        >
                          Close Ticket
                        </Button>
                      </Col>
                    </Row>
                  </div>
                ) : this.state.userDetailsbyTicketIdData.supportTicketStatus ===
                  "OPEN" ? (
                  <div>
                    <div style={{ marginTop: 20 }}>
                      <Button color="danger" onClick={this.closetickethandler}>
                        Close Ticket
                      </Button>
                    </div>
                  </div>
                ) : this.state.userDetailsbyTicketIdData.supportTicketStatus ===
                  "CLOSE" ? (
                  <div></div>
                ) : this.state.userDetailsbyTicketIdData.supportTicketStatus ===
                  "REOPEN" ? (
                  <div>
                    <div style={{ marginTop: 10 }}>
                      <Row>
                        <Col>
                          <Button
                            color="primary"
                            onClick={this.opentickethandler}
                          >
                            Open Ticket
                          </Button>
                        </Col>
                        <Col>
                          <Button
                            style={{ marginLeft: 60 }}
                            color="danger"
                            onClick={this.closetickethandler}
                          >
                            Close Ticket
                          </Button>
                        </Col>
                      </Row>
                    </div>
                  </div>
                ) : null}
              </Card.Title>
              <Card.Text>
                <Row>
                  <Col>
                    <p className="ptageticketrack">
                      Full Name:
                      <span className="spantitrack">
                        {this.state.userDetailsbyTicketIdData.fullName}
                      </span>
                    </p>
                  </Col>
                  <Col>
                    <p className="ptageticketrack">
                      Created Date:
                      <span className="spantitrack">
                        {this.state.userDetailsbyTicketIdData.createdDate}
                      </span>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="ptageticketrack">
                      Support Type:
                      <span className="spantitrack">
                        {this.state.userDetailsbyTicketIdData.supportType}
                      </span>
                    </p>
                  </Col>
                  <Col>
                    <p className="ptageticketrack">
                      Support Messege:
                      <span className="spantitrack">
                        {this.state.userDetailsbyTicketIdData.supportMessage}
                      </span>
                    </p>
                  </Col>
                </Row>
                <Row>
                  <Col>
                    <p className="ptageticketrack">
                      Support Ticket Status:
                      <span className="spantitrack">
                        {" "}
                        {
                          this.state.userDetailsbyTicketIdData
                            .supportTicketStatus
                        }
                      </span>
                    </p>
                  </Col>
                </Row>
              </Card.Text>
            </Card>
          </div>
          {this.state.userDetailsbyTicketIdData.supportTicketStatus ===
          "NEW" ? (
            <div></div>
          ) : this.state.userDetailsbyTicketIdData.supportTicketStatus ===
            "OPEN" ? (
            <div className="col-lg-12 grid-margin stretch-card">
              <Card style={{ padding: 20, marginTop: 10 }}>
                <Card.Title>
                  <p className="ptageticketrack">Ticket Comment</p>
                </Card.Title>
                <Card.Text>
                  {" "}
                  <Row>
                    <Col span={10}>
                      <p style={{ color: "red" }}>
                        {this.state.commentValueErrormsg}
                      </p>
                      <Form.Control
                        type="textarea"
                        name="text"
                        onChange={this.onChangecomment}
                        id="exampleText"
                        value={this.state.commentValue}
                      />
                      <Button
                        style={{ marginTop: 20 }}
                        onClick={this.createSupportCommentByTicketId}
                        color="primary"
                      >
                        Add Comment
                      </Button>
                    </Col>
                  </Row>
                  <div className="table-responsive">
                    <table
                      className="table table-hover table table-bordered"
                      table-bordered
                      style={{ marginTop: 10 }}
                    >
                      <thead>
                        <tr>
                          <th>Id</th>
                          <th>User Type</th>
                          <th>Full Name</th>
                          <th>Created At</th>
                          <th>Comment</th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.Allsupportcomment.map((v) => {
                          return (
                            <tr>
                              <td>{v.id}</td>
                              <td>{v.userType ? v.userType : "USER"}</td>
                              <td style={{ textTransform: "capitalize" }}>
                                {v.fullName
                                  ? v.fullName
                                  : this.state.userDetailsbyTicketIdData
                                      .fullName}
                              </td>
                              <td>{v.createdAt}</td>
                              <td>{v.comment}</td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Card.Text>{" "}
              </Card>
            </div>
          ) : this.state.userDetailsbyTicketIdData.supportTicketStatus ===
            "CLOSE" ? (
            <div className="col-lg-12 grid-margin stretch-card">
              <Card style={{ padding: 20, marginTop: 10 }}>
                <Card.Title>
                  <p className="ptageticketrack">Ticket Comment</p>
                </Card.Title>

                <div className="table-responsive">
                  <table
                    className="table table-hover table table-bordered"
                    table-bordered
                    style={{ marginTop: 10 }}
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>User Type</th>
                        <th>Full Name</th>
                        <th>Created At</th>
                        <th>Comment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.Allsupportcomment.map((v) => {
                        return (
                          <tr>
                            <td>{v.id}</td>
                            <td>{v.userType ? v.userType : "USER"}</td>
                            <td style={{ textTransform: "capitalize" }}>
                              {v.fullName
                                ? v.fullName
                                : this.state.userDetailsbyTicketIdData.fullName}
                            </td>
                            <td>{v.createdAt}</td>
                            <td>{v.comment}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>
          ) : this.state.userDetailsbyTicketIdData.supportTicketStatus ===
            "REOPEN" ? (
            <div className="col-lg-12 grid-margin stretch-card">
              <Card style={{ padding: 20, marginTop: 10 }}>
                <Card.Title>
                  <p className="ptageticketrack">Ticket Comment</p>
                </Card.Title>

                <div className="table-responsive">
                  <table
                    className="table table-hover table table-bordered"
                    table-bordered
                    style={{ marginTop: 10 }}
                  >
                    <thead>
                      <tr>
                        <th>Id</th>
                        <th>User Type</th>
                        <th>Full Name</th>
                        <th>Created At</th>
                        <th>Comment</th>
                      </tr>
                    </thead>
                    <tbody>
                      {this.state.Allsupportcomment.map((v) => {
                        return (
                          <tr>
                            <td>{v.id}</td>
                            <td>{v.userType ? v.userType : "USER"}</td>
                            <td style={{ textTransform: "capitalize" }}>
                              {v.fullName
                                ? v.fullName
                                : this.state.userDetailsbyTicketIdData.fullName}
                            </td>
                            <td>{v.createdAt}</td>
                            <td>{v.comment}</td>
                          </tr>
                        );
                      })}
                    </tbody>
                  </table>
                </div>
              </Card>
            </div>
          ) : null}
        </div>
      </div>
    );
  }
}

export default Admintickettrack;
